import type { RefObject } from "react";
import { useEffect } from "react";

export const useClickOutside = (
  ref: RefObject<HTMLElement>,
  callback: () => unknown
): void => {
  const handleClick: EventListener = (e: Event): void => {
    if (ref?.current && !ref?.current?.contains(e.target as Node)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};
